import { render, staticRenderFns } from "./SiteColumnListItem.vue?vue&type=template&id=af40ba62&"
import script from "./SiteColumnListItem.vue?vue&type=script&lang=js&"
export * from "./SiteColumnListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports